    <div class="module-header">
      <button
        *ngIf="uiConfig?.showSidebarToggle !== false"
        type="button"
        class="btn-sidebar-toggle"
        (click)="toggleSidebar.emit()"
        [title]="uiConfig?.sidebarToggleTooltip || 'Toggle sidebar'">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <line x1="9" y1="3" x2="9" y2="21"></line>
        </svg>
      </button>
      <h3>{{ title }}</h3>
      <button
        *ngIf="uiConfig?.showRefresh !== false"
        type="button"
        class="btn-refresh"
        (click)="refresh.emit()"
        [title]="uiConfig?.refreshTooltip || 'Refresh'">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 12a9 9 0 0 1-15.5 6.2"></path>
          <path d="M3 12A9 9 0 0 1 18.5 5.8"></path>
          <path d="M18 2v5h5"></path>
          <path d="M6 22v-5H1"></path>
        </svg>
      </button>
    </div>
  
